import { useMutation } from '@tanstack/react-query';
import { api } from '@/lib/api';

export type TestPushResult = {
  recipient: { user_id: string; phone: string | null; role: string; business_name: string | null };
  provider: string;
  notify_push_enabled: boolean;
  devices_registered: number;
  sent: number;
  pruned_dead_tokens: number;
  /** One sentence naming the actual cause — show this, not the counters. */
  verdict: string;
};

/** Sends a REAL push to the vendor's device(s) and reports what happened. */
export function use_test_push(vendor_profile_id: string) {
  return useMutation({
    mutationFn: async () =>
      (await api.post<TestPushResult>('/admin/notifications/test-push', { vendor_profile_id }))
        .data,
  });
}
